/**
 * Public surface of the manual cabinet-run engine. Grows as later plans
 * add fillRun, corner handling, appliance reservation, etc.
 */

const {
  solveModuleSequence,
  solveEqualModuleSequence,
  widestModuleIn,
  BASE_MODULE_WIDTHS_IN,
  MAX_MODULE_IN,
  MIN_MODULE_IN,
  MIN_FILLER_IN,
} = require('./moduleSolver');

const { fillRun } = require('./fillRun');
const {
  BAY_KINDS,
  baysForRun,
  applianceBays,
  applianceBayFromLegacy,
  legacyApplianceFromBay,
  storedRunFromRun,
  footprintForAppliance,
} = require('./bays');

const {
  resolveBayFootprint,
  resolveRunBayFootprints,
  scannedSurroundFor,
} = require('./bayFootprint');

const {
  buildApplianceObjects,
  computeWarnings,
  reservationsForSegment,
  clampApplianceCenter,
} = require('./appliances');

const {
  overridesForRun,
  fixedWidthOverridesForSegment,
  resolveBayType,
  applyBayType,
  isTallOverride,
} = require('./bayOverrides');

const { cornerIndexForUnit } = require('./corners');
const { joinRunsAtCorners, CORNER_JOIN_REACH } = require('./cornerJoin');
const { runAliases, findRunByIdOrAlias, perWallRunId } = require('./runIds');
const { stampApplianceBays, ownershipViolations } = require('./ownership');
const {
  CABINET_FAMILIES,
  DEFAULT_FAMILY_ID,
  familyById,
  familyOf,
  isUnknownFamily,
  familyWidthsIn,
  familyFillOpts,
  narrowestModuleIn,
  familySellsDiscreteWidths,
  snapWidthToFamily,
  snapTallWidthToFamily,
} = require('./families');
const {
  CABINET_PROFILES,
  KITCHEN_PROFILE_ID,
  VANITY_PROFILE_ID,
  profileById,
  profileOf,
  profileIdForRoom,
  uppersEnabled,
} = require('./profiles');
const {
  FRONT_TYPES,
  READ_ONLY_FRONTS,
  APPLIANCE_BAYS,
  frontTypesFor,
  applianceBaysFor,
  applianceElementsFor,
  frontLabelOf,
} = require('./catalog');

const {
  synthesizeVirtualWall,
  frontBackDepths,
  resolveSegmentDepths,
  fillFreestandingSegment,
  defaultSidedness,
  clusterCentresIntoRuns,
  pointToSegmentDistance,
  freeSegIndexOf,
} = require('./freestanding');

const { snapPointToReference } = require('./snap');
const {
  buildSegmentWallResolver,
  resolveSegmentWall,
  roomWallForFrame,
  nearestRoomWall,
} = require('./segmentWall');
const { RESOLVE_SITES, policyFor, uppersMode } = require('./resolvePolicy');
const { isAutoRun, isDerivedRun, isScanRun } = require('./runSource');
const { materializeRun } = require('./materializeRun');
const { mergeResolvedRuns } = require('./mergeResolvedRuns');
const { objectsAfterRunDelete } = require('./deleteRun');
const {
  reseatSinkHosts,
  emitTallUnits,
  isReseatedTallUnit,
} = require('./incumbents');
const {
  isFreestandingCountertop,
  defaultEndFinish,
  markCountertopFreestanding,
} = require('./countertopExposure');

const {
  isOvenColumnBay,
  bayResolvesToOvenColumn,
  columnPartsFor,
  ovenColumnPartsForBay,
  groupOvenColumns,
  columnFootprint,
} = require('./ovenColumn');

const {
  wallAxis,
  perpOffset,
  onSameWall,
  SAME_WALL_PERP_TOLERANCE,
} = require('./sameWall');
const {
  PRICE_LIST_COLLECTION,
  editionId,
  validatePriceList,
  currentEdition,
  priceFor,
} = require('./priceList');
const {
  familySizes,
  resolveCabinetSku,
  unitsOf,
  colourCodeFor,
} = require('./vendorSizes');
const { familyFieldsForNewRun } = require('./newRunFamily');

module.exports = {
  stampApplianceBays,
  ownershipViolations,
  CABINET_FAMILIES,
  DEFAULT_FAMILY_ID,
  familyById,
  familyOf,
  isUnknownFamily,
  familyWidthsIn,
  familyFillOpts,
  narrowestModuleIn,
  familySellsDiscreteWidths,
  snapWidthToFamily,
  snapTallWidthToFamily,
  CABINET_PROFILES,
  KITCHEN_PROFILE_ID,
  VANITY_PROFILE_ID,
  profileById,
  profileOf,
  profileIdForRoom,
  uppersEnabled,
  FRONT_TYPES,
  READ_ONLY_FRONTS,
  APPLIANCE_BAYS,
  frontTypesFor,
  applianceBaysFor,
  applianceElementsFor,
  frontLabelOf,
  joinRunsAtCorners,
  CORNER_JOIN_REACH,
  runAliases,
  findRunByIdOrAlias,
  perWallRunId,
  wallAxis,
  perpOffset,
  onSameWall,
  SAME_WALL_PERP_TOLERANCE,
  solveModuleSequence,
  solveEqualModuleSequence,
  widestModuleIn,
  BASE_MODULE_WIDTHS_IN,
  MAX_MODULE_IN,
  MIN_MODULE_IN,
  MIN_FILLER_IN,
  fillRun,
  BAY_KINDS,
  baysForRun,
  applianceBays,
  applianceBayFromLegacy,
  legacyApplianceFromBay,
  storedRunFromRun,
  footprintForAppliance,
  resolveBayFootprint,
  resolveRunBayFootprints,
  scannedSurroundFor,
  buildApplianceObjects,
  computeWarnings,
  reservationsForSegment,
  clampApplianceCenter,
  overridesForRun,
  fixedWidthOverridesForSegment,
  resolveBayType,
  applyBayType,
  isTallOverride,
  cornerIndexForUnit,
  synthesizeVirtualWall,
  frontBackDepths,
  resolveSegmentDepths,
  fillFreestandingSegment,
  defaultSidedness,
  clusterCentresIntoRuns,
  pointToSegmentDistance,
  freeSegIndexOf,
  snapPointToReference,
  buildSegmentWallResolver,
  resolveSegmentWall,
  roomWallForFrame,
  nearestRoomWall,
  RESOLVE_SITES,
  policyFor,
  uppersMode,
  isAutoRun,
  isDerivedRun,
  isScanRun,
  materializeRun,
  mergeResolvedRuns,
  objectsAfterRunDelete,
  reseatSinkHosts,
  emitTallUnits,
  isReseatedTallUnit,
  isFreestandingCountertop,
  defaultEndFinish,
  markCountertopFreestanding,
  isOvenColumnBay,
  bayResolvesToOvenColumn,
  columnPartsFor,
  ovenColumnPartsForBay,
  groupOvenColumns,
  columnFootprint,
  PRICE_LIST_COLLECTION,
  editionId,
  validatePriceList,
  currentEdition,
  priceFor,
  familySizes,
  resolveCabinetSku,
  unitsOf,
  colourCodeFor,
  familyFieldsForNewRun,
};
